import { MenuItem, TextField } from '@mui/material';

import { Sprint } from '@/tracker/types';

import s from './SprintSelect.module.scss';

const SPRINT_STATUS_LABELS = { active: 'активный', draft: 'черновик', closed: 'закрыт' };

type Props = {
  /** id спринта; '' — без спринта */
  value: string;
  onChange: (value: string) => void;
  /** Открытые спринты досок очереди */
  sprints: Sprint[];
  hasQueue: boolean;
};

/** Спринт новой задачи: в поле — одной строкой, в списке — с доской и статусом */
const SprintSelect: React.FC<Props> = ({ value, onChange, sprints, hasQueue }) => (
  <TextField
    select
    size="small"
    fullWidth
    disabled={!hasQueue}
    value={value}
    onChange={(event) => onChange(event.target.value)}
    slotProps={{
      select: {
        displayEmpty: true,
        SelectDisplayProps: { 'aria-label': 'Спринт' },
        renderValue: (id) => {
          const sprint = sprints.find((item) => item.id === id);

          return sprint ? `${sprint.name} · ${sprint.board.name}` : 'Без спринта';
        },
      },
    }}
  >
    <MenuItem value="">
      {sprints.length || !hasQueue ? 'Без спринта' : 'У досок очереди нет открытых спринтов'}
    </MenuItem>
    {sprints.map((sprint) => (
      <MenuItem key={sprint.id} value={sprint.id}>
        <span className={s.sprint}>
          {sprint.name}
          <span className={s.sprint__meta}>
            {sprint.board.name} · {SPRINT_STATUS_LABELS[sprint.status]}
          </span>
        </span>
      </MenuItem>
    ))}
  </TextField>
);

export { SprintSelect };
